<template>
  <div class="rc-tree">
    <div class="search-bob">
      <rc-search
        v-model.trim="search"
        v-bind="$attrs.search"
        class="self-filter-input"
        :placeholder="$t('common.search')"
        :class="'cursor-p'"
        @click="searchTree"
        v-on="$listeners"
      />
    </div>
    <el-tree
      ref="tree"
      class="self-tree"
      :data="treeData"
      :node-key="nodeKey"
      :highlight-current="highlightCurrent"
      :expand-on-click-node="expandOnClickNode"
      :default-expanded-keys="defaultExpandedKeys"
      :default-checked-keys="defaultCheckedKeys"
      :filter-node-method="filterNode"
      v-bind="$attrs"
      @node-click="handleNodeClick"
      @node-expand="handleNodeExpand"
      @node-collapse="handleNodeCollapse"
      v-on="$listeners"
    >
      <slot>
        <span slot-scope="{ node }" :title="node.label" class="self-custom-tree">
          <span>{{ node.label }}</span>
        </span>
      </slot>
    </el-tree>
  </div>
</template>

<script>
import RcSearch from "@/components/RcBase/RcSearch";
import { commonFilterNode, strFirstWith, getApi, isPlainObject } from "@/utils";

export default {
  name: "RcTree",
  components: {
    RcSearch
  },
  props: {
    nodeKey: {
      type: String,
      default: "id"
    },
    highlightCurrent: {
      type: Boolean,
      default: false
    },
    expandOnClickNode: {
      type: Boolean,
      default: false
    },
    isCreated: {
      type: Boolean,
      default: false
    },
    isMounted: {
      type: Boolean,
      default: true
    },
    api: {
      type: Object,
      default: () => ({
        model: "",
        name: ""
      })
    },
    params: {
      type: Object,
      default: () => ({})
    },
    // 没有传递个params，eg: (id, params)
    otherParams: Function,
    loading: {
      type: String,
      default: "loading"
    },
    paramsStructure: Function,
    treeList: Function,
    treeDataCall: Function,
    recordName: {
      type: String,
      default: ""
    },
    rowKey: {
      type: String,
      default: "id"
    }
  },
  data() {
    return {
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      currentNode: {},
      load: {},
      treeData: [],
      search: ""
    };
  },
  computed: {
    refs() {
      return {
        tree: this.$refs.tree
      };
    },
    tree() {
      return this.refs.tree;
    },
    isApi() {
      return this.isApiFn("api");
    }
  },
  created() {
    this.initApi("created");
  },
  mounted() {
    this.initApi("mounted");
  },
  methods: {
    setCurrentKey(id) {
      const { tree } = this;
      tree && tree.setCurrentKey(id);
    },
    setCheckedKeys(ids) {
      const { tree } = this;
      tree && tree.setCheckedKeys(ids);
    },
    setCurrentNode(node) {
      this.currentNode = node;
    },
    setDefaultExpandedKeys(id) {
      this.defaultExpandedKeys.push(id);
    },
    handleNodeClick(node) {
      // this.$emit('node-click', node);
      this.setCurrentKey(this.currentNode[this.rowKey]);
    },
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultExpandedKeys.some(item => {
        if (item === data[this.rowKey]) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.setDefaultExpandedKeys(data[this.rowKey]);
      }
      // this.$emit('node-expand', data, flag);
    },
    handleNodeCollapse(data) {
      this.defaultExpandedKeys.some((item, i) => {
        if (item === data[this.rowKey]) {
          // 删除关闭节点
          this.defaultExpandedKeys.length = i;
        }
      });
      // this.$emit('node-collapse', data, this.defaultExpandedKeys);
    },
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    initApi(type) {
      this[`is${strFirstWith(type)}`] && this.isApi && this.getTree({ bool: true });
    },
    isApiFn(api) {
      const { model, name } = this[api];
      return model && name && model[name];
    },
    initParams(params) {
      return {
        ...params || {},
        ...this.params
      };
    },
    customStructure(params, name) {
      const { paramsStructure } = this;
      return paramsStructure ? paramsStructure(this.initParams(params), name) : params;
    },
    withData(data, res) {
      return Array.isArray(data) ? data : isPlainObject(data) ? [data] : this.treeList && this.treeList(data, res);
    },
    initData({ params, bool = false }) {
      getApi({
        self: this,
        loading: this.loading,
        api: this.isApi,
        name: "tree",
        otherParams: this.otherParams,
        params: this.customStructure(this.initParams(params), "tree"),
        call: (data, res) => {
          this.treeData = this.recordName ? data[this.recordName] : this.withData(data, res);
          const [first] = this.treeData;
          if (first && bool) {
            this.setCurrentNode(first);
            this.$nextTick(() => {
              this.setDefaultExpandedKeys(first[this.rowKey]);
              this.setCheckedKeys([first[this.rowKey]]);
            });
          }
          this.$nextTick(() => {
            this.setCurrentKey(this.currentNode[this.rowKey]);
          });
          const funData = { first, data: this.treeData };
          this.treeDataCall && this.treeDataCall(funData);
          this.$emit("tree-data", funData);
        }
      });
    },
    getTree(obj) {
      this.initData(obj);
    },
    searchTree(val) {
      this.tree.filter(val);
    }
  }
};
</script>

<style>

</style>
